import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import moment from "moment";
import SelectorGrid from "../form/SelectorGrid/SelectorGrid";
import {Link} from "react-router-dom";
import urldecode from "locutus/php/url/urldecode";
import {paramsSerializer, postData} from "../../utils/request";
import Icon from "../form/Icon";
import {EmailFormatter, UnitFormatter} from "../../utils/formatters";
import DateTimeInput from "../form/DateTimeInput";
import ShippingReportList from "./lists/ShippingReportList";
import EmailTemplateEditor from "./EmailTemplateEditor";
import connect from "react-redux/es/connect/connect";

const sortable = true;
const filterable = true;

class Filter extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            from: this.props.from,
            to: this.props.to
        }
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        const state = {};
        if (this.props.from !== prevProps.from && this.state.from === prevState.from) {
            state.from = this.props.from;
        }
        if (this.props.to !== prevProps.to && this.state.to === prevState.to) {
            state.to = this.props.to;
        }
        if (Object.keys(state).length) {
            this.setState(state);
        }
    }

    render() {
        return (
            <div className="row">
                <div className="col-md-3">
                    <div className="form-group">
                        <DateTimeInput
                            maxDate={this.state.to}
                            value={this.state.from}
                            label="Időszak"
                            saveChanges={(field, from) => this.setState({from})}
                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="form-group">
                        <DateTimeInput
                            minDate={this.state.from}
                            value={this.state.to}
                            maxDate={moment().format("YYYY-MM-DD")}
                            label="&nbsp;"
                            saveChanges={(field, to) => this.setState({to})}
                        />
                    </div>
                </div>
                <div className="col-md-2">
                    <label className="control-label">&nbsp;</label>
                    <Button
                        color="primary"
                        block={true}
                        icon={{lib: "fa", name: "search"}}
                        onClick={() => {
                            this.props.onFilter({from: this.state.from, to: this.state.to});
                        }}
                    >
                        Szűrés
                    </Button>
                </div>
            </div>
        );
    }
}

class ShippingReportGenerator extends React.Component {

    state = {
        from: moment().subtract(1, "months").startOf('month').format("YYYY-MM-DD"),
        to: moment().subtract(1, "months").endOf('month').format("YYYY-MM-DD")
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        if (!this.props.pos) {
            return <Box header="Hiba" theme="danger">
                Kérlek jelentkezz be egy eladási helyre!
            </Box>;
        }
        const startdate = this.state.from + " 00:00:00";
        const enddate = this.state.to + " 23:59:59";

        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return <Fragment>
                <List
                    {...this.props}
                    collapsed={this.props.collapsed || false}
                    theme="default"
                    header="Riportok"
                >
                    <ShippingReportList
                        ref={(el) => this.list = el}
                        {...this.props}
                        loadForm={null}
                        filter={[
                            {field: "agent", value: this.props.pos.partner.partner_id},
                            {field: "type", value: 2}
                        ]}
                    />
                </List>
            <Box>
                <Filter
                    from={this.state.from}
                    to={this.state.to}
                    onFilter={({from, to}) => {
                        this.setState({from, to});
                    }}
                />
                <SelectorGrid
                    ref={(list) => this.partnerList = list}
                    className={"p-small-table"}
                    component="ShippingReportPartner"
                    pageSize={50}
                    loading={this.props.isLoading}
                    reqparams={{exact: true}}
                    filter={[
                        {field: "close_date", value: [startdate, enddate], operator: "between"},
                        {field: "report_exists", value: 0},
                        {field: "state", value: 10},
                        {field: "transfer", value: 1},
                        {field: "business_service_provider", value: this.props.pos.partner.partner_id}
                    ]}
                    onLoadCompleted={(response) => {
                        response = {...response};
                        response.aggregations = [{}];
                        return response;
                    }}
                    view={["partner_id"]}
                    columns={{
                        "action.view": {
                            header: " ",
                            renderer: (v, rowData) => {
                                return (
                                    <Link
                                        class="btn btn-default btn-xs btn-block"
                                        to={"?" + urldecode(paramsSerializer({option: "partner", partner_id: rowData.partner_id}))}
                                    >
                                        <Icon lib="fas" name="pencil-alt"/>
                                    </Link>
                                );
                            }
                        },
                        "name": {
                            header: "Név",
                            sortable,
                            filterable,
                        },
                        "email": {
                            header: "Email",
                            sortable,
                            filterable,
                            renderer: EmailFormatter
                        },
                        "count": {
                            header: "Csomagszám",
                            width: 1,
                            className: "unit",
                            sortable,
                            filterable,
                            renderer: (value, row) => UnitFormatter(value, row.unit),
                        },
                        "action.send": {
                            header: " ",
                            renderer: (v, rowData) => {
                                return (
                                    <Button
                                        block={true}
                                        color="default"
                                        size="xs"
                                        icon={{lib: "fas", name: "shapes"}}
                                        disabled={this.props.isLoading}
                                        onClick={() => {
                                            this.props.processAction(async () => {
                                                const res = await postData({
                                                    action: 'ShippingReport.create',
                                                    data: {
                                                        type: 2,
                                                        partner: rowData.partner_id,
                                                        startdate,
                                                        enddate,
                                                    }
                                                });
                                                this.partnerList && this.partnerList.refresh();
                                                this.list && this.list.refresh();
                                                return res;
                                            });
                                        }}
                                    >
                                        Generálás
                                    </Button>
                                );
                            },
                            aggregation: () => {
                                return (
                                    <Button
                                        block={true}
                                        color="primary"
                                        size="xs"
                                        icon={{lib: "fas", name: "shapes"}}
                                        disabled={this.props.isLoading}
                                        onClick={() => {
                                            this.props.processAction(async () => {
                                                const res = await postData({
                                                    action: 'ShippingReport.bulkCreate',
                                                    type: 2,
                                                    startdate,
                                                    enddate,
                                                });
                                                this.partnerList && this.partnerList.refresh();
                                                this.list && this.list.refresh();
                                                return res;
                                            });
                                        }}
                                    >
                                        Generálás
                                    </Button>
                                );
                            }
                        },
                        "action.preview": {
                            header: " ",
                            renderer: (v, rowData) => {
                                return (
                                    <Button
                                        block={true}
                                        color="default"
                                        size="xs"
                                        icon={{lib: "fas", name: "eye"}}
                                        disabled={this.props.isLoading}
                                        onClick={() => {
                                            this.props.processAction(async () => {
                                                return await postData({
                                                    action: 'ShippingReport.preview',
                                                    data: {
                                                        type: 2,
                                                        partner_id: rowData.partner_id,
                                                        startdate,
                                                        enddate,
                                                    }
                                                });
                                            });
                                        }}
                                    >
                                        Előnézet
                                    </Button>
                                );
                            }
                        },
                    }}
                    orderBy={{field: "name", direction: "ASC"}}
                />
            </Box>
            <EmailTemplateEditor
                filter={[{field: "token", value: this.props.componentConfig.config.email_template}]}
                fieldForm={this.props.componentConfig.config.email_template}
                editorContext="ShippingReportEmailTemplate"
            />
        </Fragment>;
    }
}

export default connect((state) => {
    return {
        pos: (state.app.till || {}).pos,
    };
}, {})(createEditor({
    componentName: "ShippingReport",
    WrappedComponent: ShippingReportGenerator
}));
